// Computes a sort key for vendor/category names that ignores a leading
// article so, e.g., "(The) Berry Patch" and "The Berry Patch" both sort
// under "B". Falls back to the original name when no article is present.

const LEADING_ARTICLE = /^\s*(?:\(the\)|the)\s+/i;

export function sortKey(name: string): string {
  return name.replace(LEADING_ARTICLE, '').trim().toLowerCase();
}
